module.exports = __webpack_public_path__ + "static/media/81mJ-Mdc-OL._AC_SL1500_.bdb5ec09.jpg";